import { render } from "./Impacts.vue?vue&type=template&id=5446109e&scoped=true"
import script from "./Impacts.vue?vue&type=script&lang=js"
export * from "./Impacts.vue?vue&type=script&lang=js"

import "./Impacts.vue?vue&type=style&index=0&id=5446109e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5446109e"]])

export default __exports__